import React from 'react';

import { Overlay } from './styles';

interface LoadingOverlayProps {
  visible: boolean;
  // eslint-disable-next-line react/require-default-props
  message?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  visible,
  message = 'Carregando…',
}) => {
  if (!visible) return null;

  return (
    <Overlay role="status" aria-live="polite" aria-busy="true">
      <div className="loader" />
      <p>{message}</p>
    </Overlay>
  );
};

export default LoadingOverlay;
